import styled from 'styled-components';

const SlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(40)};
  @media (max-width: 900px) {
    padding: 0;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  padding-top: 60%;
  position: relative;
  .slider-image {
    max-width: 100%;
    margin-bottom: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const SlideCaptionWrapper = styled.div`
  width: 900px;
  max-width: 90%;
  position: relative;
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  margin: 50px auto;
  gap: 10px;
  .iconWrapper{
    position: relative;
    display: flex;
    flex-flow: column;
    grid-column: span 2 / span 2;
    align-self: center;
  }
  .textWrapper{
    position: relative;
    display: flex;
    flex-flow: column;
    grid-column: span 10 / span 10;
    align-self: center;
  }
  @media (max-width: 760px) {
    margin: 20px auto;
    width: 100%;
    .iconWrapper{
      img{
        max-width: 100%;
      }
    }
  }
`;

export const SlideTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: ${({ theme }) => theme.spacing(12)};
  text-align: left;
  color: ${({ theme }) => theme.colours.yellow};
`;

export const SlideCaption = styled.div`
  p{
    color: ${({ theme }) => theme.colours.tan};
    margin-bottom: 0;
    font-size: 22px;
    text-align: left;
    @media (max-width: 760px) {
      font-size: 18px;
    }
  }
`;

export default SlideWrapper;